import endpoints from '@/services/http/endpoints'
import http from '@/services/http/index'

export default {
  get(payload, assigned = false) {
    const endpoint = assigned
      ? 'childEditionPreviousEditionAssigned'
      : 'childEditionPreviousEdition'
    return http.get(endpoints.get(endpoint, { ...payload }))
  },
  getPesel(childEditionId) {
    return http.get(endpoints.get('peselPreviousEdition', { childEditionId }))
  }
}
